/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { TextInput } from '../../Components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { Link } from 'react-router-dom'
import { colors } from '../../Themes'
import { PrimaryButton } from '../../Components/Button/Button'
import useStyles from './Verification.styles'

function Verification({ pin, setPin, error, next }) {
  const classes = useStyles()
  return (
    <>
      <h1 style={{ color: colors.accent }}>Verification PIN</h1>
      <span className={classes.description}>
        We've sent a verification PIN in your email. Enter it below:
      </span>
      <TextInput label="PIN" value={pin} setValue={setPin} />
      {Boolean(error) && <span className="loginError">{error}</span>}
      <PrimaryButton
        style={
          pin===''
            ? { marginTop: 30, backgroundColor: colors.disabled, minHeight: 50 }
            : { marginTop: 30, backgroundColor: colors.accent, minHeight: 50 }
        }
        className={classes.loginButton}
        onClick={next}
        disabled={pin===''}
      >
        Next
      </PrimaryButton>
      <Link
        style={{
          display: 'flex',
          alignSelf: 'flex-start',
          textDecoration: 'none',
          color: colors.secondary,
          marginTop: 15,
          alignItems: 'center',
        }}
        to="/login"
      >
        <ArrowBackIcon classes={{ root: classes.rootBackIcon }} />
        <span className="logoutDrawer">Back to Login</span>
      </Link>
    </>
  )
}

export default Verification
